import Mutations from '../../odata/mutations';

const moviesMutations = new Mutations('movies');
const movieMutations = new Mutations('movie');

export default { ...movieMutations, ...moviesMutations };
